export const INVENTORY_SEARCH_INDEX = 1;
export const INVENTORY_SEARCH_DB = 2;
export const INVENTORY_SEARCH_SOM = 3;
export const INVENTORY_SEARCH_PDP = 4;
